import isEqual from 'lodash/isEqual';
import { requestSelector } from 'pages/requestForm/selectors/pageSelectors';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { localClearingSystemKey } from '../../AddBeneficiaryPopupContent.constants';
import {
    accountCurrencyKey,
    bankCountryCodeKey,
    entityTypeKey,
    paymentMethodKey,
} from '../../AddBeneficiaryPopupContent.constants';
import { FormValues } from '../../AddBeneficiaryPopupContent.types';
import { UseAddBeneficiaryRoutingProps } from './NavigationButtons.types';

export const useAddBeneficiaryRouting = ({
    activeStep,
    setActiveStep,
    setErrorMessages,
    setFieldsSchemaTransfer,
    fieldsSchema,
    fieldsSchemaTransfer,
}: UseAddBeneficiaryRoutingProps) => {
    const request = useSelector(requestSelector);

    const form = useFormContext<FormValues>();

    const goToPrevStep = useCallback(() => {
        setActiveStep(activeStep - 1);
        setErrorMessages([]);
    }, [activeStep, setActiveStep, setErrorMessages]);

    const goToNextStep = useCallback(() => {
        form.trigger().then((value) => {
            if (!value) return;

            const accountCurrency = form.getValues(accountCurrencyKey);
            const bankCountryCode = form.getValues(bankCountryCodeKey);
            const entityType = form.getValues(entityTypeKey);

            if (activeStep === 1) {
                setFieldsSchemaTransfer({
                    companyId: request.companyId,
                    accountCurrency,
                    bankCountryCode,
                    entityType,
                });
            }

            if (activeStep === 2) {
                const paymentMethod = form.getValues(paymentMethodKey);
                const localClearingSystem = form.getValues(localClearingSystemKey);

                const newFieldsSchemaTransfer = {
                    companyId: request.companyId,
                    accountCurrency,
                    bankCountryCode,
                    entityType,
                    paymentMethod,
                    localClearingSystem: fieldsSchema?.find((field) => field.path === localClearingSystemKey)
                        ? localClearingSystem
                        : undefined,
                };

                if (!isEqual(fieldsSchemaTransfer, newFieldsSchemaTransfer)) {
                    setFieldsSchemaTransfer(newFieldsSchemaTransfer);
                }
            }

            setActiveStep((activeStep) => activeStep + 1);
        });
    }, [
        form,
        activeStep,
        setActiveStep,
        setFieldsSchemaTransfer,
        request.companyId,
        fieldsSchema,
        fieldsSchemaTransfer,
    ]);

    return { goToPrevStep, goToNextStep };
};
